<script setup lang="ts">
import { LANDING_MEMBERSHIP } from '@/content/landing'

const { payouts } = LANDING_MEMBERSHIP
</script>

<template>
  <UICard variant="band" band="member">
    <div class="member-grid">
      <UISection
        :level="2"
        band="none"
        :kicker="LANDING_MEMBERSHIP.kicker"
        :title="LANDING_MEMBERSHIP.heading"
        :subtitle="LANDING_MEMBERSHIP.lead"
        class="member-grid__intro"
      />

      <!-- Benefits, not steps: no numbers and no connecting line, so they don't read as a sequence. -->
      <article
        v-for="item in LANDING_MEMBERSHIP.items"
        :key="item.id"
        class="benefit-card"
        :class="item.id === 'document' ? 'benefit-card--document' : 'benefit-card--adjuster'"
      >
        <!-- A viewfinder snapping onto a home: the proof is taken before anything happens. -->
        <svg
          v-if="item.id === 'document'"
          class="benefit-art benefit-art--document"
          viewBox="0 0 120 80"
          aria-hidden="true"
        >
          <g class="benefit-art__house">
            <path d="M36 42 60 22l24 20" />
            <path d="M41 38v28h38V38" />
            <path d="M55 66V53h10v13" />
          </g>
          <g class="benefit-art__frame">
            <path d="M24 26V14h12" />
            <path d="M84 14h12v12" />
            <path d="M96 58v12H84" />
            <path d="M36 70H24V58" />
          </g>
          <g class="benefit-art__badge">
            <circle cx="96" cy="14" r="9" />
            <path d="m91.5 14 3 3 5.5-6" />
          </g>
        </svg>

        <!-- Two sides of one conversation: your photos, and the adjuster backing you up. -->
        <svg
          v-else
          class="benefit-art benefit-art--adjuster"
          viewBox="0 0 120 80"
          aria-hidden="true"
        >
          <g class="benefit-art__bubble benefit-art__bubble--you">
            <path d="M18 10h46a10 10 0 0 1 10 10v10a10 10 0 0 1-10 10H26l-10 7 2-7a10 10 0 0 1-8-10V20a10 10 0 0 1 8-10Z" />
            <rect x="19" y="17" width="18" height="16" rx="2.5" class="benefit-art__photo" />
            <path d="m21 31 5-6 4 4 2-2 4 4" class="benefit-art__photo-line" />
            <path d="M43 21h21M43 28h14" class="benefit-art__line" />
          </g>
          <g class="benefit-art__bubble benefit-art__bubble--adjuster">
            <path d="M56 36h46a10 10 0 0 1 8 10v10a10 10 0 0 1-8 10l2 7-10-7H56a10 10 0 0 1-10-10V46a10 10 0 0 1 10-10Z" />
            <path d="m58 51 4.5 4.5L71 47" class="benefit-art__check" />
            <path d="M78 47h22M78 55h15" class="benefit-art__line benefit-art__line--light" />
          </g>
        </svg>

        <h3 class="mt-4 font-heading text-lg font-bold tracking-tight text-ink">
          {{ item.title }}
        </h3>
        <p class="mt-1.5 text-[0.92rem]/relaxed text-ink-soft">
          {{ item.body }}
        </p>
      </article>

      <article class="benefit-card benefit-card--payouts">
        <div class="min-w-0">
          <h3 class="font-heading text-lg font-bold tracking-tight text-ink">
            {{ payouts.title }}
          </h3>
          <p class="mt-1.5 text-[0.92rem]/relaxed text-ink-soft">
            {{ payouts.body }}
          </p>

          <div class="payout-claim mt-5">
            <p class="payout-claim__label">
              {{ payouts.afterClaim.label }}
            </p>
            <h4 class="mt-1 font-heading text-base font-bold tracking-tight text-ink">
              {{ payouts.afterClaim.title }}
            </h4>
            <p class="mt-1 text-[0.92rem]/relaxed text-ink-soft">
              {{ payouts.afterClaim.body }}
            </p>
          </div>
        </div>

        <LandingPayoutSketch />
      </article>
    </div>
  </UICard>
</template>
